/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Thu Jun 6 2019 3:16:54 PM
 *
 *******************************************************/
//@flow

import _ from 'lodash';
import React, { useEffect } from 'react';
import { TextField } from '@shopify/polaris';
import { RenderLabelTooltip } from './render-label-tooltip';

export const RenderTextField = (field: Object) => {
  const { input } = field;
  let { value } = input;
  value = _.isNil(value) ? value : value.toString();

  useEffect(() => {
    return () => {
      field.onUnmount && field.onUnmount();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <RenderLabelTooltip label={field.label} tooltip={field.tooltip} />
      <TextField
        id={field.input.name}
        value={value}
        type={field.type}
        min={field.min}
        max={field.max}
        onChange={field.input.onChange}
        onFocus={field.input.onFocus}
        placeholder={field.placeholder ? field.placeholder : ''}
        error={!!field.meta.error && !!field.meta.touched ? field.meta.error : ''}
        onBlur={field.input.onBlur}
        suffix={field.suffix}
        {...field.anotherProps}
      />
    </div>
  );
};
